import { render, staticRenderFns } from "./returnRecordAudit.vue?vue&type=template&id=20213b28&scoped=true"
import script from "./returnRecordAudit.vue?vue&type=script&lang=js"
export * from "./returnRecordAudit.vue?vue&type=script&lang=js"
import style0 from "./returnRecordAudit.vue?vue&type=style&index=0&id=20213b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20213b28",
  null
  
)

export default component.exports